import { useMemo, useState } from "react";

//PROJECT IMPORTS

import {
  Col,
  DatePicker,
  Form,
  Input,
  Row,
  Select,
  Tag,
  Typography,
} from "antd";
import { labelConfig, staticConfig } from "../serviceProvider.config";
import { BOM } from "../../../services/definedMethod";
import ChevronDown from "@untitled-ui/icons-react/build/esm/ChevronDown";

// import { apiConfig, labelConfig } from "../../../contractbooking.config";

// import "../../../../../../../assets/css/Interbank.css";

const { Text } = Typography;

const Others = (props) => {
  const {
    form,
    initialValues,
    disabledAfterCurrentDate,
    disableDaysBeforeToday,
    isLoading,
    formData,
    walletProduct,
    openCasa,
    clientClassificationData,
    staffData,
    isCreateScreen,
  } = props;
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 10;
  console.log(walletProduct);

  return (
    <>
      <Form
        className="custom-form"
        layout="vertical"
        form={form}
        initialValues={initialValues}
        style={{ width: "100%" }}
        disabled={true}
      >
        {/* <Row gutter={16}>
          <Col span={8}>
            <Form.Item label="Relationship Manager">
              <Select placeholder="Select manager" />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Customer Classification">
              <Select placeholder="Select customer classification" />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Assign Default Product">
              <Select value="Yes" />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label="Wallet Product">
              <Select placeholder="Select wallet product" />
            </Form.Item>
          </Col>
        </Row> */}

        <Row>
          {/* {!(legalOption === 2) && (
                    <Col span={12} style={{ padding: "0px 8px" }}>
                      <Form.Item label={labelConfig.isStaff} name="isStaff">
                        <Select
                          style={{ height: "44px" }}
                          placeholder={BOM.handlePlaceholderMsg(
                            labelConfig.isStaff,
                            "select"
                          )}
                          options={staticConfig.yesOrNoData}
                          showSearch
                        />
                      </Form.Item>
                    </Col>
                  )} */}

          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item label={labelConfig.relationshipManager} name="staffId">
              <Select
                style={{ height: "44px" }}
                placeholder={BOM.handlePlaceholderMsg(
                  labelConfig.relationshipManager,
                  "select",
                )}
                options={staffData}
                className="read-only-select"
                suffixIcon={<ChevronDown color="#667085" width={20} />}
              />
            </Form.Item>
          </Col>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={labelConfig.customerClassification}
              name="clientClassificationId"
            >
              <Select
                style={{ height: "44px" }}
                placeholder={BOM.handlePlaceholderMsg(
                  labelConfig.customerClassification,
                  "select",
                )}
                options={clientClassificationData}
                className="read-only-select"
                suffixIcon={<ChevronDown color="#667085" width={20} />}
              />
            </Form.Item>
          </Col>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={labelConfig.walletProduct}
              name="savingsProductId"
            >
              <Select
                style={{ height: "44px" }}
                placeholder={BOM.handlePlaceholderMsg(
                  labelConfig.walletProduct,
                  "select",
                )}
                options={walletProduct}
                className="read-only-select"
                suffixIcon={<ChevronDown color="#667085" width={20} />}
              />
            </Form.Item>
          </Col>
          {isCreateScreen && (
            <>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.assignDefaultProduct}
                  name="openCasa"
                >
                  <Select
                    style={{ height: "44px" }}
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.assignDefaultProduct,
                      "select",
                    )}
                    options={staticConfig.yesOrNoData}
                    className="read-only-select"
                    suffixIcon={<ChevronDown color="#667085" width={20} />}
                  />
                </Form.Item>
              </Col>
              {openCasa && (
                <Col span={12} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={labelConfig.walletProduct}
                    name="savingsProductId"
                    rules={[
                      {
                        required: true,
                        message: BOM.CheckReqFld(labelConfig.walletProduct),
                      },
                    ]}
                  >
                    <Select
                      style={{ height: "44px" }}
                      placeholder={BOM.handlePlaceholderMsg(
                        labelConfig.walletProduct,
                        "select",
                      )}
                      options={walletProduct}
                      className="read-only-select"
                      suffixIcon={<ChevronDown color="#667085" width={20} />}
                    />
                  </Form.Item>
                </Col>
              )}
            </>
          )}
          {/* <Col span={12} style={{ padding: "0px 8px" }}>
                    <Form.Item
                      label={labelConfig.submittedOn}
                      name="submittedOnDate"
                      rules={[
                        {
                          required: true,
                          message: BOM.CheckReqFld(labelConfig.submittedOn),
                        },
                      ]}
                    >
                      <DatePicker
                        disabledDate={disabledAfterCurrentDate}
                        placeholder={BOM.handlePlaceholderMsg(
                          labelConfig.submittedDate,
                          "select"
                        )}
                        style={{ width: "100%", height: "44px" }}
                      />
                    </Form.Item>
                  </Col> */}
        </Row>
      </Form>
    </>
  );
};

export default Others;
